const homeAudiencesPath = '/app/audiences';
const homePath = '/app/dashboard';
const conversationsPath = '/app/conversations';

export { conversationsPath, homeAudiencesPath, homePath };
